<template>
  <div class="chart-wrapper">
    <canvas ref="ratingChart"></canvas>
  </div>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "CustomerSatisfactionChart",
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const ctx = this.$refs.ratingChart.getContext("2d");

      new Chart(ctx, {
        type: "bar", // 👉 ใช้ bar แต่เปลี่ยนแกน
        data: {
          labels: ["5 ★", "4 ★", "3 ★", "2 ★", "1 ★"],
          datasets: [
            {
              label: "Total Response Received",
              data: [95, 75, 45, 25, 15],
              backgroundColor: [
                "#2ecc71",
                "#a3c644",
                "#f5a623",
                "#f57c00",
                "#e53935",
              ],
              borderRadius: 8,
            },
          ],
        },
        options: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              callbacks: {
                title: (ctx) => `${ctx[0].label} star rating`,
                label: (ctx) => `Total Response Received : ${ctx.raw}`,
              },
            },
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback: (value) => value + "%",
              },
              title: {
                display: true,
                text: "Base on Total Response Received", // ✅ แกน X
                font: {
                  size: 13,
                  weight: "500",
                },
                padding: { top: 10 },
              },
            },
            y: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Number of Ticket", // ✅ แกน Y
                font: {
                  size: 13,
                  weight: "500",
                },
                padding: { bottom: 10 },
              },
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.chart-wrapper {
  height: 320px;
}
</style>
